import InfoIcon from '@mui/icons-material/Info';
import { Box, IconButton, List } from '@mui/material';
import React from 'react';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { getInitials } from '~/services/Employee';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  teamMembers: People.TeamMemberDto[];
  activeMemberId?: number;
  handleActiveMemberChange: (employeeId: number) => void;
  handleShowMemberDetails: (employeeId: number) => void;
}

export const EmployeeList: React.FC<Props> = ({
  teamMembers,
  activeMemberId,
  handleActiveMemberChange,
  handleShowMemberDetails,
}) => {
  const sxStyles = useSxStyles();

  const listItems = teamMembers.map((employee: People.TeamMemberDto) => {
    return (
      <div key={employee.employeeId}>
        <SummaryItem
          key={employee.employeeId}
          avatarProps={{
            alt: getInitials(employee.firstName, employee.lastName),
            src: employee.profilePic,
          }}
          listItemProps={{ disableGutters: true }}
          primaryElement={`${employee.firstName} ${employee.lastName}`}
          secondaryElement={employee.positionName.value}
          sx={sxStyles.avatar}
          onClick={() => handleActiveMemberChange(employee.employeeId)}
          secondaryActions={
            <IconButton
              edge="end"
              onClick={() => handleShowMemberDetails(employee.employeeId)}
              data-cy="info-icon"
              size="large"
              sx={sxStyles.icon}
            >
              <InfoIcon color="primary" />
            </IconButton>
          }
          isActive={employee.employeeId === activeMemberId}
        />
      </div>
    );
  });

  return (
    <Box data-cy="list" sx={sxStyles.list}>
      <List sx={sxStyles.mainList}>{listItems}</List>
    </Box>
  );
};
